import { Box, Group, Paper, SimpleGrid, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import type { FeePolicy } from "../../apis/tenantFeePolicy";
import { PolicyMiniCard } from "./PolicyMiniCard";

interface Props {
  policies: FeePolicy[];
  /** Map: policyId → number of customers assigned to that NAMED policy. */
  customerCountByPolicy?: Record<string, number>;
  /** True once the reach counts have loaded (lets cards show a real 0-state). */
  countsLoaded?: boolean;
}

/** Dashed "+" tile that opens an empty NAMED editor (spec §2.3). */
function NewNamedCard() {
  const navigate = useNavigate();
  return (
    <Paper
      p="md"
      radius="md"
      withBorder
      style={{
        cursor: "pointer",
        height: "100%",
        borderStyle: "dashed",
        borderColor: "var(--mantine-color-gray-4)",
      }}
      onClick={() => navigate("/my-billing/fee-policy/editor?scope=NAMED")}>
      <Stack gap="xs" align="center" justify="center" h="100%" py="md">
        <ThemeIcon variant="light" color="brand" size={40} radius="xl"><IconPlus size={22} /></ThemeIcon>
        <Text fw={600} size="sm">Шинэ нэрлэсэн бодлого</Text>
        <Text size="xs" c="dimmed" ta="center">Тусгай хувьтай бодлого үүсгэх</Text>
      </Stack>
    </Paper>
  );
}

export function PolicyNamedListCard({ policies, customerCountByPolicy, countsLoaded }: Props) {
  return (
    <Box>
      <Group justify="space-between" mb="sm">
        <Stack gap={2}>
          <Text fw={600}>Нэрлэсэн бодлогууд</Text>
          <Text size="xs" c="dimmed">
            Тодорхой харилцагчдад зориулсан тусгай шимтгэл. Оноогдоогүй бусад харилцагч Үндсэн бодлогоор тооцогдоно.
          </Text>
        </Stack>
      </Group>

      {policies.length === 0 && (
        <Text size="xs" c="dimmed" mb="sm">Тусгай хувь өгөх бол шинэ нэрлэсэн бодлого үүсгээрэй.</Text>
      )}

      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="md">
        {policies.map((p) => (
          <PolicyMiniCard
            key={p.id}
            policy={p}
            customerCount={customerCountByPolicy?.[p.id]}
            countsLoaded={countsLoaded}
          />
        ))}
        <NewNamedCard />
      </SimpleGrid>
    </Box>
  );
}
